import { api_configuration } from "../../common";
import { IdPathBuilder, Raw_Id_Path_Head } from "../navigation/IdPathBuilder";
import read_api = api_configuration.types.client_state.alan_api;

function walkNodeLocation(
	node: read_api.Cnode,
	onTail: (parent_context: IdPathBuilder) => IdPathBuilder
): IdPathBuilder {
	const position = node.input.position();
	switch (position.variant.name) {
		case "entity": {
			const entity = position.variant.definition;
			switch (entity.variant.name) {
				case "root":
					return onTail(IdPathBuilder.create());
				case "entry": {
					const entry = entity.variant.definition;
					const key_property = entry.properties.key.ref;

					const backend_value = key_property.properties.backend_known.switch({
						no: () => undefined,
						yes: ($) => $.properties.value,
					});
					const set_value = key_property.properties.is_set.switch({
						no: "",
						yes: ($) => $.properties.text,
					});
					let key_value = backend_value ?? set_value;
					// If the key property is being saved but has not yet received an update from the backend
					// use the modified value as if it is the backend value to prevent timing issues
					switch (key_property.properties.is_editable.state.name) {
						case "yes": {
							const editable = key_property.properties.is_editable.state.node;
							switch (editable.properties.modified.state.name) {
								case "yes": {
									const modified = editable.properties.modified.state.node;
									switch (modified.properties.saving.state.name) {
										case "yes": {
											key_value = set_value;
											break;
										}
										case "no":
											break;
										default:
											unexpectedState(modified.properties.saving.state);
									}
									break;
								}
								case "no":
									break;
								default:
									unexpectedState(editable.properties.modified.state);
							}
							break;
						}
						case "no":
							break;
						default:
							unexpectedState(key_property.properties.is_editable.state);
					}

					return walkNodeLocation(entry.parent.parent.parent.parent, (parent) =>
						onTail(parent.collectionEntry(entry.parent.parent.parent.key.entry, key_value))
					);
				}
				default:
					unexpectedState(entity.variant);
			}
			break;
		}
		case "group": {
			const group = position.variant.definition;
			return walkNodeLocation(group.parent.parent.parent, (parent) =>
				onTail(parent.group(group.parent.parent.key.entry))
			);
		}
		case "state": {
			const state = position.variant.definition;
			return walkNodeLocation(state.parent.parent.parent.parent, (parent) =>
				onTail(parent.state(state.parent.parent.parent.key.entry, state.key.entry))
			);
		}
		case "root":
			return onTail(IdPathBuilder.create());
		default:
			unexpectedState(position.variant);
	}
}

export function createIdPathBuilderToEntity(node: read_api.Cnode): IdPathBuilder {
	return walkNodeLocation(node.input.entity().input.node(), function ($) {
		return $;
	});
}
export function createIdPathBuilderFromNode(node: read_api.Cnode): IdPathBuilder {
	return walkNodeLocation(node, function ($) {
		return $;
	});
}
export function createIdPathFromNode(node: read_api.Cnode): Raw_Id_Path_Head {
	return createIdPathBuilderFromNode(node).build();
}
